import { render, staticRenderFns } from "./CabeceraModalCreacion.vue?vue&type=template&id=18208c8c&scoped=true&"
import script from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalCreacion.vue?vue&type=style&index=0&id=18208c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18208c8c",
  null
  
)

export default component.exports